var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuAvatar(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z",
    fill: "#65A300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.321 20.11c.007-.161.012-.323.012-.486 0-6.589-5.39-11.95-12.02-11.957v3.941c4.448.003 8.054 3.595 8.054 8.016 0 .164-.007.326-.017.486h3.971z",
    fill: "#fff",
    stroke: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.022 24.333c2.406 0 4.356-1.89 4.356-4.223 0-2.332-1.95-4.223-4.356-4.223-2.405 0-4.355 1.89-4.355 4.223 0 2.332 1.95 4.223 4.355 4.223z",
    fill: "#fff",
    stroke: "#fff"
  })));
}
export default SvgMenuAvatar;